export default "__VITE_ASSET__CqhfWJCn__"